export interface TimelineItem {
  id: string;
  time: string;
  cat: string;
  title: string;
  summary: string;
  heat: number;      // 讨论热度百分比 1-100
  discuss: string;   // 参与讨论数，如 "2.3万"
  tag?: string;      // 状态标签
  fresh?: boolean;
}

export interface HotItem {
  id: string;
  rank: number;
  title: string;
  heat: string;      // 热度数值
  up: string;        // 上升幅度说明
  cat: string;
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  blurb: string;
  count: string;
  trend: string;
}

export interface TopicItem {
  id: string;
  title: string;
  desc: string;
  talks: string;
  members: string;
  img: string;
  hot: boolean;
}

export interface FeatureItem {
  id: string;
  kicker: string;
  title: string;
  excerpt: string;
  mins: string;
  views: string;
  img: string;
  author: string;
}

export interface Testimonial {
  id: string;
  name: string;
  role: string;
  quote: string;
}

export interface Faq {
  id: string;
  q: string;
  a: string;
}

export const siteName = '吃瓜网爆';

export const categories: Category[] = [
  { id: 'ent', name: '娱乐八卦', icon: 'ri-star-smile-line', blurb: '台前幕后的热度与反转', count: '1,286 条', trend: '涨 12%' },
  { id: 'film', name: '影视综艺', icon: 'ri-movie-2-line', blurb: '剧集、舞台与热搜名场面', count: '974 条', trend: '涨 8%' },
  { id: 'society', name: '社会热议', icon: 'ri-bubble-chart-line', blurb: '身边事里的讨论与共鸣', count: '1,502 条', trend: '涨 21%' },
  { id: 'tech', name: '科技圈', icon: 'ri-flashlight-line', blurb: '发布会、产品与新动向', count: '612 条', trend: '涨 6%' },
  { id: 'sports', name: '体育竞技', icon: 'ri-trophy-line', blurb: '赛场内外的高光时刻', count: '438 条', trend: '涨 15%' },
  { id: 'life', name: '生活圈', icon: 'ri-cup-line', blurb: '美食、职场与城市话题', count: '801 条', trend: '涨 9%' },
];

export const timeline: TimelineItem[] = [
  { id: 'tl1', time: '刚刚', cat: '娱乐八卦', title: '新综艺杀青现场流出彩排片段，导师团私下互动被热议', summary: '一段未剪彩排路透在网上快速扩散，网友围绕几位导师的临场反应展开讨论，话题讨论量正在攀升。', heat: 96, discuss: '2.3万', tag: '爆', fresh: true },
  { id: 'tl2', time: '12分钟前', cat: '社会热议', title: '城市夜宵街搬迁方案公开征求意见，商户与食客反应不一', summary: '街区升级方案进入公示期，有人期待新面貌，也有人担心烟火气被稀释，评论区观点明显分化。', heat: 88, discuss: '1.1万', tag: '热', fresh: true },
  { id: 'tl3', time: '35分钟前', cat: '影视综艺', title: '年度悬疑剧预告上线两小时破纪录，细节彩蛋被逐帧分析', summary: '预告里埋下的几处呼应镜头被逐帧解读，关于剧情走向的猜测帖正在热榜发酵。', heat: 92, discuss: '1.8万', tag: '新' },
  { id: 'tl4', time: '1小时前', cat: '科技圈', title: '新款旗舰机样张集中曝光，夜景算法对比成为焦点', summary: '多家数码博主同步放出实拍样张，夜景与长焦表现成为最受关注的对比项，参数党争论不休。', heat: 79, discuss: '8600', tag: '热' },
  { id: 'tl5', time: '1.5小时前', cat: '体育竞技', title: '洲际赛资格战加时绝杀，赛后采访金句刷屏', summary: '一场关键资格战的加时绝杀点燃讨论，赛后短短一段采访被网友反复引用，正能量话题持续走高。', heat: 85, discuss: '1.4万' },
  { id: 'tl6', time: '2小时前', cat: '生活圈', title: '「反内耗指南」短视频走红，职场松弛感引发共鸣', summary: '一组关于工作边界与情绪管理的短视频被大量转发，评论区涌进大量真实职场故事，讨论从深夜延续到上午。', heat: 83, discuss: '2.0万', tag: '爆' },
  { id: 'tl7', time: '3小时前', cat: '娱乐八卦', title: '老牌主持人透露节目幕后趣事，怀旧弹幕集体刷屏', summary: '一次访谈里聊起的陈年录制趣事戳中许多人回忆，相关怀旧话题被重新顶到前列。', heat: 74, discuss: '6200' },
  { id: 'tl8', time: '4小时前', cat: '社会热议', title: '小城青年返乡创业样本引发讨论，县域新业态成热点', summary: '一篇关于小城咖啡与文创空间增长的报道，让「县域新消费」重新进入话题中心，观点与数据并存。', heat: 71, discuss: '5400' },
];

export const hotList: HotItem[] = [
  { id: 'h1', rank: 1, title: '新综艺导师团彩排互动片段全网扩散', heat: '942.6万', up: '上升 218', cat: '娱乐' },
  { id: 'h2', rank: 2, title: '年度悬疑剧预告细节被逐帧解析', heat: '876.3万', up: '上升 154', cat: '影视' },
  { id: 'h3', rank: 3, title: '夜宵街改造方案公示引发双面讨论', heat: '811.5万', up: '上升 203', cat: '社会' },
  { id: 'h4', rank: 4, title: '旗舰新机夜景样张算法大对比', heat: '704.2万', up: '上升 89', cat: '科技' },
  { id: 'h5', rank: 5, title: '反内耗指南戳中职场松弛感共鸣', heat: '655.8万', up: '上升 176', cat: '生活' },
  { id: 'h6', rank: 6, title: '洲际资格战加时绝杀金句刷屏', heat: '598.1万', up: '上升 132', cat: '体育' },
  { id: 'h7', rank: 7, title: '小城返乡创业样本带火县域话题', heat: '492.7万', up: '上升 98', cat: '社会' },
  { id: 'h8', rank: 8, title: '老牌主持人节目幕后趣事引怀旧', heat: '433.9万', up: '上升 61', cat: '娱乐' },
  { id: 'h9', rank: 9, title: '国漫电影续作首支预告定档引发期待', heat: '388.4万', up: '上升 74', cat: '影视' },
  { id: 'h10', rank: 10, title: '城市通勤路线夜间巴士增班引讨论', heat: '312.6万', up: '上升 42', cat: '生活' },
];

export const topics: TopicItem[] = [
  { id: 'tp1', title: '#今天热搜里你最关注哪一条#', desc: '把今天反复被顶的话题都摆出来，聊聊你真正想追的那一条，顺便给还在发酵的猛料添把火。', talks: '3.6万', members: '12.4万', hot: true, img: 'https://readdy.ai/api/search-image?query=editorial%20scene%20of%20a%20warm%20coral%20glowing%20phone%20screen%20at%20center%20surrounded%20by%20soft%20cream%20studio%20backdrop%2C%20scattered%20paper%20notes%20and%20amber%20light%20flares%2C%20cinematic%20rim%20lighting%2C%20slight%20film%20grain%2C%20magazine%20cover%20mood%2C%20no%20readable%20text&width=800&height=600&seq=topic-fire-001&orientation=landscape' },
  { id: 'tp2', title: '#今晚吃什么 夜宵图鉴#', desc: '夜宵街改造的正反两面都聊，今天先晒你心里最舍不得的那口烟火气，看看各地吃货的底气。', talks: '2.8万', members: '9.7万', hot: true, img: 'https://readdy.ai/api/search-image?query=warm%20editorial%20photography%20of%20a%20cozy%20late%20night%20street%20food%20corner%20with%20soft%20amber%20lanterns%20and%20steam%20rising%2C%20blurred%20warm%20bokeh%20background%2C%20cinematic%20cream%20and%20coral%20tones%2C%20cozy%20atmosphere%2C%20no%20readable%20text&width=800&height=600&seq=topic-night-002&orientation=landscape' },
  { id: 'tp3', title: '#这届国产剧真的支棱起来了#', desc: '从预告细节到整季口碑，一部剧的逆袭路径怎么被一步步盘出来，来盘盘今年让你改观的剧。', talks: '1.9万', members: '7.2万', hot: false, img: 'https://readdy.ai/api/search-image?query=stylized%20cinema%20theme%20editorial%20image%20with%20warm%20spotlight%20beam%20cutting%20through%20a%20dusty%20cream%20studio%2C%20film%20reel%20and%20soft%20coral%20wash%2C%20cinematic%20depth%2C%20artistic%20mood%2C%20no%20readable%20text&width=800&height=600&seq=topic-drama-003&orientation=landscape' },
  { id: 'tp4', title: '#上班族的情绪自救指南#', desc: '把职场里的内耗与松弛摆上台面，交换你的真实解法，看看大家都是怎么把日子过顺的。', talks: '1.6万', members: '8.5万', hot: false, img: 'https://readdy.ai/api/search-image?query=minimal%20editorial%20illustration%20of%20a%20calm%20desk%20with%20a%20laptop%20and%20a%20small%20potted%20plant%2C%20warm%20cream%20wall%20with%20soft%20morning%20light%2C%20coral%20accent%20blanket%2C%20peaceful%20atmosphere%2C%20clean%20composition%2C%20no%20readable%20text&width=800&height=600&seq=topic-work-004&orientation=landscape' },
  { id: 'tp5', title: '#小城的新生意经#', desc: '当咖啡与文创开进县城，一批返乡年轻人靠什么把流量做起来，来聊聊你身边的新业态。', talks: '9800', members: '4.6万', hot: false, img: 'https://readdy.ai/api/search-image?query=warm%20editorial%20shot%20of%20a%20small%20town%20cafe%20with%20brick%20wall%20and%20hanging%20warm%20bulbs%2C%20young%20people%20chatting%2C%20cozy%20cream%20and%20amber%20tones%2C%20lifestyle%20magazine%20style%2C%20no%20readable%20text&width=800&height=600&seq=topic-town-005&orientation=landscape' },
  { id: 'tp6', title: '#今晚的加时绝杀你看哭了吗#', desc: '一场加时赛和一个金句，把赛场内外的情绪都点燃了，来聊聊你为哪一刻红了眼眶。', talks: '8600', members: '3.9万', hot: false, img: 'https://readdy.ai/api/search-image?query=dynamic%20editorial%20sports%20image%20of%20a%20lit%20stadium%20at%20night%20with%20warm%20floodlights%2C%20silhouettes%20of%20celebrating%20players%2C%20confetti%20in%20air%2C%20coral%20and%20gold%20light%2C%20energetic%20atmosphere%2C%20no%20readable%20text&width=800&height=600&seq=topic-sport-006&orientation=landscape' },
];

export const features: FeatureItem[] = [
  { id: 'f1', kicker: '独家复盘', title: '从「被质疑」到「被追更」：一部剧口碑逆袭的完整链路', excerpt: '当热搜里的讨论从吐槽转向自发安利，背后其实是内容团队、观众与传播节奏三方的同频。我们把这场逆袭的关键节点一条条拆开，看看热度到底是怎么被一步步盘起来的。', mins: '6 分钟读完', views: '18.2万', author: '吃瓜网爆·深度组', img: 'https://readdy.ai/api/search-image?query=cinematic%20editorial%20behind%20the%20scenes%20collage%20about%20a%20tv%20series%20comeback%2C%20warm%20cream%20studio%20with%20dramatic%20coral%20and%20amber%20light%20rays%2C%20film%20clapper%20and%20storyboard%20sheets%2C%20artistic%20shadows%2C%20magazine%20feature%20mood%2C%20no%20readable%20text&width=1200&height=760&seq=feature-drama-101&orientation=landscape' },
  { id: 'f2', kicker: '现象观察', title: '夜宵街与县城咖啡馆：烟火气和生意经正在双向奔赴', excerpt: '一条街的改造、一家店的爆火，背后是城市更新与年轻人消费选择在对话。我们从几个具体切片出发，聊聊县域新消费凭什么能把流量变成回头客。', mins: '8 分钟读完', views: '21.4万', author: '吃瓜网爆·观察组', img: 'https://readdy.ai/api/search-image?query=warm%20editorial%20documentary%20style%20image%20of%20a%20charming%20narrow%20night%20street%20with%20glowing%20signs%20and%20a%20small%20cafe%20entrance%2C%20people%20strolling%2C%20cream%20and%20amber%20tones%20with%20coral%20accents%2C%20cinematic%20composition%2C%20no%20readable%20text&width=1200&height=760&seq=feature-town-102&orientation=landscape' },
  { id: 'f3', kicker: '赛场特写', title: '加时、绝杀与一句金句：那一夜的情绪是怎样被点燃的', excerpt: '竞技体育最迷人的部分常常在比分之外。我们从赛后采访里那句话出发，拆解一段十几秒的表达，如何成为被反复引用的能量标签。', mins: '5 分钟读完', views: '12.7万', author: '吃瓜网爆·赛场组', img: 'https://readdy.ai/api/search-image?query=night%20stadium%20dramatic%20editorial%20image%2C%20warm%20floodlight%20halos%2C%20a%20ball%20in%20mid%20air%20caught%20by%20silhouetted%20players%2C%20confetti%20sparkles%2C%20coral%20and%20gold%20color%20palette%2C%20cinematic%20high%20contrast%2C%20no%20readable%20text&width=1200&height=760&seq=feature-sport-103&orientation=landscape' },
];

export const testimonials: Testimonial[] = [
  { id: 'g1', name: '追热点的小满', role: '常驻吃瓜用户', quote: '上班前十分钟刷一遍时间线，今天哪些话题在被反复顶、哪条刚起来的猛料值得点进去，心里就有数了。' },
  { id: 'g2', name: '阿布的评论区', role: '话题常客', quote: '最喜欢热榜那个上升的箭头，能看出话题是刚热起来还是在降温，追起来特别有方向感。' },
  { id: 'g3', name: '夜猫子瓜友', role: '深夜活跃用户', quote: '专题深读那几篇真的把热度背后的逻辑拆明白了，看完不再只是吃个热闹，能看出门道来。' },
];

export const faqs: Faq[] = [
  { id: 'q1', q: '吃瓜网爆上的热点会多久更新一次？', a: '首页「今日速览」信息流会按时间持续滚动更新，刚刚发酵的爆点和反复被顶的热门事件会靠前呈现；旁边的全网热榜则标注每个话题的热度数值与上升/降温趋势，方便你快速判断哪些是今天真正值得追的内容。' },
  { id: 'q2', q: '点开一条资讯之后能看到完整讨论吗？', a: '可以。每条热点都配有简介与「进入讨论」入口，点开后你会进入对应的讨论页，按时间查看网友的发言脉络；首页侧边的「全网热榜」与底部「热门话题」也都支持直接跳转到对应讨论，避免来回翻找。' },
  { id: 'q3', q: '这里的内容是怎么来的？', a: '吃瓜网爆编辑部会人工筛选全网高热、有讨论价值的事件，再由观察组撰写内容方向与专题复盘，确保每一条都有来龙去脉可循，而不是简单堆砌标题。你可以把它理解成一群爱上网的人帮你把瓜剥好、摆整齐。' },
  { id: 'q4', q: '我也想分享一条自己发现的热点，该怎么做？', a: '直接使用页面底部的「投稿爆料」表单，填写你的称呼、联系方式、话题方向与具体内容即可。编辑部会审核线索的价值与真实性，素材足够扎实的会被整理成可读的热点或专题呈现给大家。' },
  { id: 'q5', q: '内容会不会有失实或带节奏的情况？', a: '我们坚持「先理脉络、再谈观点」的原则：事实陈述与主观评论会明确区分，存在多方说法的事件会并列呈现而非抢先定调。若发现线索需要补充或更正，也欢迎通过底部表单反馈，我们会及时跟进。' },
  { id: 'q6', q: '现在需要付费才能使用吗？', a: '不需要。浏览今日速览、全网热榜、话题广场与专题深读都是免费的。我们优先保障内容质量和浏览体验，如未来推出会员或增值功能，会在页面显著位置提前告知。' },
];